module.exports = "https://s91588.cdn.ngenix.net/home/_next/static/images/variant-b-credits-online-a3a0d37c370a4510843ab5782e8fddb2.png";